import { Button, EmptyState, SectionLabel } from '@localina/core';
import { PeopleIcon, SearchIcon } from '@localina/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

const STEPS = ['online', 'phone', 'visits'] as const;
const GHOST_ROWS = 3;

export const GuestsDatabaseEmpty: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="guests-empty">
            <EmptyState icon={<PeopleIcon />} title={t('guests.empty.title')} text={t('guests.empty.text')}>
                <div className="guests-empty__how">
                    <SectionLabel value={t('guests.empty.howTitle')} />
                    <ol className="guests-empty__steps">
                        {STEPS.map((step, index) => (
                            <li key={step} className="guests-empty__step">
                                <span className="guests-empty__step-number" aria-hidden={true}>
                                    {index + 1}
                                </span>
                                <div>
                                    <div className="guests-empty__step-title">
                                        {t(`guests.empty.steps.${step}.title`)}
                                    </div>
                                    <div className="guests-empty__step-text">
                                        {t(`guests.empty.steps.${step}.text`)}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </EmptyState>
        </div>
    );
};

interface INoResultsProps {
    query: string;
    onClear: () => void;
}

export const GuestsNoResults: React.FC<INoResultsProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="guests-no-results">
            <EmptyState
                size="small"
                icon={<SearchIcon />}
                title={t('guests.noResults.title', { query: props.query })}
                text={t('guests.noResults.text')}
                action={<Button secondary label={t('guests.noResults.clear')} onClick={props.onClear} />}
            />
            <div className="guests-no-results__ghosts" aria-hidden={true}>
                {Array.from({ length: GHOST_ROWS }, (_, index) => (
                    <div key={index} className="guests-no-results__ghost">
                        <span className="guests-no-results__ghost-avatar" />
                        <div className="guests-no-results__ghost-lines">
                            <span />
                            <span />
                        </div>
                        <span className="guests-no-results__ghost-meta" />
                    </div>
                ))}
            </div>
        </div>
    );
};
